import { Navigate } from 'react-router-dom';
import { APP_PATHS } from '@/app/routes/paths';

/** The bare app domain always enters through the feed route. */
export default function RootRedirect() {
  return <Navigate to={APP_PATHS.feed} replace />;
}
